// router.js

import Vue from "vue";
import VueRouter from "vue-router";
// 导入要使用的组件
import Index from "./components/Index.vue";
import messageDetail from "./components/solutionPage/MessageDetail.vue";
Vue.use(VueRouter);

const routes = [
  { path: "/", component: Index },
  { path: "/solution", component: Index },
  {
    name: "showRoomDetail",
    path: "/showRoomDetail/:id",
    component: messageDetail,
  },
  { path: "*", component: Index },
];

const router = new VueRouter({
  routes,
});

export default router;
